import { moveToFulfilled } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { FeedLoadAction } from '../../domains/feedLoad/actions.types';
import type { PublishGroupMessageFulfilledAction } from '../../domains/publishers/actions.types';
import type { NormalizedThreadEntities } from '../../normalization/types';

import type { GroupFeedsLastVisited } from './types';

export type GroupFeedLastVisitedAction = FeedLoadAction | PublishGroupMessageFulfilledAction;

const initialState: GroupFeedsLastVisited = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const updateLastVisited = (state: GroupFeedsLastVisited, groupId: string, entities: NormalizedThreadEntities) => {
  const { messages } = entities;
  const newMessage = messages && Object.values(messages).length === 1 ? Object.values(messages)[0] : undefined;

  const { fulfilled } = state;
  const lastVisited = fulfilled.byId[groupId];

  if (lastVisited) {
    const newMessageDate = Date.now();
    const newMessageId = newMessage?.id || undefined;
    const newMessageThreadId = newMessage?.threadId || undefined;

    const newLastVisited = {
      ...lastVisited,
      viewerLastVisitedAt: newMessageDate,
      lastVisitMessageId: newMessageId,
      lastVisitThreadId: newMessageThreadId,
    };

    return {
      ...state,
      fulfilled: {
        ...fulfilled,
        byId: {
          ...fulfilled.byId,
          [groupId]: { ...lastVisited, ...newLastVisited },
        },
      },
    };
  }

  return state;
};

const reducer: Reducer<GroupFeedsLastVisited, GroupFeedLastVisitedAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupFeedsLastVisited);
    case 'PUBLISHER.PUBLISH_GROUP_MESSAGE_FULFILLED':
      return updateLastVisited(state, action.payload.groupId, action.payload.entities);
    default:
      return state;
  }
};

export default reducer;
